/* tslint:disable */
/* eslint-disable */
/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ArtistHeroSectionDto } from '../models';
/**
 * ArtistHerosApi - axios parameter creator
 */
export const ArtistHerosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} artistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistHerosArtistIdGet: async (artistId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'artistId' is not null or undefined
            assertParamExists('apiArtistHerosArtistIdGet', 'artistId', artistId)
            const localVarPath = `/api/ArtistHeros/{artistId}`
                .replace(`{${"artistId"}}`, encodeURIComponent(String(artistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ArtistHeroSectionDto} [artistHeroSectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistHerosPost: async (artistHeroSectionDto?: ArtistHeroSectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ArtistHeros`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(artistHeroSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ArtistHeroSectionDto} [artistHeroSectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistHerosPut: async (artistHeroSectionDto?: ArtistHeroSectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ArtistHeros`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(artistHeroSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtistHerosApi - functional programming interface
 */
export const ArtistHerosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtistHerosApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} artistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistHerosArtistIdGet(artistId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistHerosArtistIdGet(artistId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistHerosApi.apiArtistHerosArtistIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ArtistHeroSectionDto} [artistHeroSectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistHerosPost(artistHeroSectionDto?: ArtistHeroSectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistHerosPost(artistHeroSectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistHerosApi.apiArtistHerosPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ArtistHeroSectionDto} [artistHeroSectionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiArtistHerosPut(artistHeroSectionDto?: ArtistHeroSectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiArtistHerosPut(artistHeroSectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArtistHerosApi.apiArtistHerosPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArtistHerosApi - factory interface
 */
export const ArtistHerosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtistHerosApiFp(configuration)
    return {
        /**
         * 
         * @param {ArtistHerosApiApiArtistHerosArtistIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistHerosArtistIdGet(requestParameters: ArtistHerosApiApiArtistHerosArtistIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistHerosArtistIdGet(requestParameters.artistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistHerosApiApiArtistHerosPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistHerosPost(requestParameters: ArtistHerosApiApiArtistHerosPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistHerosPost(requestParameters.artistHeroSectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ArtistHerosApiApiArtistHerosPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiArtistHerosPut(requestParameters: ArtistHerosApiApiArtistHerosPutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiArtistHerosPut(requestParameters.artistHeroSectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiArtistHerosArtistIdGet operation in ArtistHerosApi.
 */
export interface ArtistHerosApiApiArtistHerosArtistIdGetRequest {
    readonly artistId: string
}

/**
 * Request parameters for apiArtistHerosPost operation in ArtistHerosApi.
 */
export interface ArtistHerosApiApiArtistHerosPostRequest {
    readonly artistHeroSectionDto?: ArtistHeroSectionDto
}

/**
 * Request parameters for apiArtistHerosPut operation in ArtistHerosApi.
 */
export interface ArtistHerosApiApiArtistHerosPutRequest {
    readonly artistHeroSectionDto?: ArtistHeroSectionDto
}

/**
 * ArtistHerosApi - object-oriented interface
 */
export class ArtistHerosApi extends BaseAPI {
    /**
     * 
     * @param {ArtistHerosApiApiArtistHerosArtistIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistHerosArtistIdGet(requestParameters: ArtistHerosApiApiArtistHerosArtistIdGetRequest, options?: RawAxiosRequestConfig) {
        return ArtistHerosApiFp(this.configuration).apiArtistHerosArtistIdGet(requestParameters.artistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistHerosApiApiArtistHerosPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistHerosPost(requestParameters: ArtistHerosApiApiArtistHerosPostRequest = {}, options?: RawAxiosRequestConfig) {
        return ArtistHerosApiFp(this.configuration).apiArtistHerosPost(requestParameters.artistHeroSectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ArtistHerosApiApiArtistHerosPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiArtistHerosPut(requestParameters: ArtistHerosApiApiArtistHerosPutRequest = {}, options?: RawAxiosRequestConfig) {
        return ArtistHerosApiFp(this.configuration).apiArtistHerosPut(requestParameters.artistHeroSectionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

